export default "__VITE_ASSET__07d2d204__"